import React from 'react';
import { CompanyLogo } from '@/Components/shared';
import GoToDesktop from './GoToDesktop.svg';
import UIStrings from '@/Utils/UIStrings';

function GetFullExperiencePage(): React.JSX.Element {
    return (
        <div className="h-svh overflow-y-auto">
            <div className="flex flex-col items-start justify-center gap-8 px-4 py-8">
                <CompanyLogo />
                <div className="text-left">
                    <span className="text-menu-title text-2xl font-semibold tracking-tight">
                        {`${UIStrings.GetFull} `}
                        <span className="text-primary-main">{UIStrings.TalentMeshExperience}</span>
                        {` ${UIStrings.OnYourDesktopBrowser}`}
                    </span>
                </div>
                <div className="text-left">
                    <span className="text-left">{UIStrings.WeWorkHard}</span>
                    <div className="mt-1 text-left">
                        <span>
                            {`${UIStrings.PleaseVisitSite} `}
                            <span className="font-bold">{window.location.host}</span>
                            {` ${UIStrings.PleaseVisitAfterSite}`}
                        </span>
                    </div>
                </div>
                <div className="flex w-full flex-row justify-center">
                    <object type="image/svg+xml" data={GoToDesktop} aria-label={UIStrings.GoToDesktop} />
                </div>
            </div>
        </div>
    );
}

export default GetFullExperiencePage;
